import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UserTrackingEffects } from './tracking/user-tracking.effects';
import { UserEffects } from './user.effects';
import { userFeature } from './user.reducer';

@NgModule({
  imports: [StoreModule.forFeature(userFeature), EffectsModule.forFeature([UserEffects, UserTrackingEffects])],
})
export class UserStoreModule {}
